import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminSettingsUpdateStoreBranchStatusParam } from "features/admin/core/admin.params";
import { AxiosError } from "axios";
import {
  AdminSettingsUpdateStoreBranchStatusRepository,
  AdminSettingsUpdateStoreBranchStatusResponse,
} from "features/admin/data/repository/admin.repository";
import { RootState } from "features/config/store";

export enum AdminSettingsUpdateStoreBranchStatusState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: AdminSettingsUpdateStoreBranchStatusState;
  message: string;
}

const initialState: InitialState = {
  status: AdminSettingsUpdateStoreBranchStatusState.initial,
  message: "",
};

export const adminSettingsUpdateStoreBranchStatus = createAsyncThunk(
  "adminSettingsUpdateStoreBranchStatus",
  async (
    param: AdminSettingsUpdateStoreBranchStatusParam,
    { rejectWithValue }
  ) => {
    try {
      const response: AdminSettingsUpdateStoreBranchStatusResponse =
        await AdminSettingsUpdateStoreBranchStatusRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const adminSettingsUpdateStoreBranchStatusSlice = createSlice({
  name: "adminSettingsUpdateStoreBranchStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminSettingsUpdateStoreBranchStatus.pending, (state) => {
        state.status = AdminSettingsUpdateStoreBranchStatusState.inProgress;
      })
      .addCase(
        adminSettingsUpdateStoreBranchStatus.fulfilled,
        (state, action) => {
          if (action.payload) {
            const { message } = action.payload;

            state.status = AdminSettingsUpdateStoreBranchStatusState.success;
            state.message = message;
          }
        }
      )
      .addCase(
        adminSettingsUpdateStoreBranchStatus.rejected,
        (state, action) => {
          state.status = AdminSettingsUpdateStoreBranchStatusState.fail;
          state.message = action.payload as string;
        }
      );
  },
});

export const selectAdminSettingsUpdateStoreBranchStatus = (state: RootState) =>
  state.adminSettingsUpdateStoreBranchStatus;

export default adminSettingsUpdateStoreBranchStatusSlice.reducer;
